"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createElement("svg", {
  width: "5",
  height: "8",
  viewBox: "0 0 5 8"
}, _react.default.createElement("path", {
  d: "M4.32 5.82A.5.5 0 003.93 5H1.07a.5.5 0 00-.39.82l1.44 1.72c.2.24.56.24.76 0l1.44-1.72zM.68 2.18a.5.5 0 00.39.82h2.86a.5.5 0 00.39-.82L2.88.46a.5.5 0 00-.76 0L.68 2.18z"
}));

exports.default = _default;